import React, { useState, useEffect } from 'react';
import { format } from 'date-fns';

const Datetime: React.FC<{ date: Date }> = ({ date }) => {
  const [currentTime, setCurrentTime] = useState(format(date, 'hh:mm:ss a'));
  const [currentDate, setCurrentDate] = useState(format(date, 'EE, MMMM dd yyyy'));

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(format(new Date(), 'hh:mm a'));
      setCurrentDate(format(new Date(), 'EE, MMMM dd yyyy'));
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <time className="d-none d-md-block px-4 lh-sm border-start border-end me-3 min-w-7-5" dateTime={date.toISOString()}>
      <div className='text-primary'>{currentTime}</div>
      <div className='text-light fs-10 text-nowrap'>{currentDate}</div>
    </time>
  );
};

export default Datetime;
